import frovTheme from './frov';
import nofrovTheme from './nofrov';
import {EFrovSign} from '../types';

const getTheme = (themStr: EFrovSign) => {
  switch (themStr) {
    case 'frov':
      return frovTheme;
    case 'nonfrov':
      return nofrovTheme;
    default:
      return frovTheme;
  }
};
export default getTheme;
